//create a dropdown for day of month selection

import React, { useEffect, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { getImageUrl } from "src/Common/common";

export default function DayDropdown({ day, setDay, placeholder = "Select day" }) {
  const [isDropDownShown, setIsDropDownShown] = useState(false);
  const [days, setDays] = useState([]);

  useEffect(() => {
    const array = [];
    for (let i = 1; i <= 31; i++) {
      array.push(i);
    }
    setDays(array);
  }, []);

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setIsDropDownShown(false);
      }}
    >
      <div
        onClick={() => setIsDropDownShown(!isDropDownShown)}
        className="w-full col-span-1 flex items-center justify-between cursor-pointer relative h-10 px-3 gap-3 rounded-[6px] border-[1px] border-borderColor bg-white"
      >
        <span
          className={`flex-1 font-OpenSansRegular text-[14px] leading-[20px] tracking-[0.14px] break-words ${
            day > 0 ? "text-titleColor" : "text-[#868DA6]"
          }`}
        >
          {day > 0 ? day : placeholder}
        </span>
        <img
          src={getImageUrl("/images/common/arrow-down.png")}
          className="w-5 h-5 shrink-0"
        />

        {isDropDownShown && (
          <div data-tour="rep-dropdown-list" className="w-full absolute px-1 py-1 rounded-[6px] border-borderColor border-[1px] shadow-xl left-0 bottom-[44px] z-10 bg-white flex flex-col max-h-[200px] overflow-auto">
            {days.map((item, index) => {
              const isSelected = item === day;
              return (
                <div
                  key={index}
                  className={`w-full flex items-center gap-2 px-2 h-9 rounded-[4px] cursor-pointer ${
                    isSelected ? "bg-[#EAF3FF]" : "bg-white hover:bg-[#F7F9FC]"
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDay(item);
                    setIsDropDownShown(false);
                  }}
                >
                  <p
                    className={`font-OpenSansRegular text-[14px] leading-[20px] tracking-[0.14px] ${
                      isSelected ? "text-[#0065FD]" : "text-titleColor"
                    }`}
                  >
                    {item}
                  </p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
}
